/**
 * @author       Digitsensitive <digit.sensitivee@gmail.com>
 * @copyright    2018 Digitsensitive
 * @description  Coin Runner: Game Scene
 * @license      Digitsensitive
 */

import { Coin } from "../objects/coin";
import { Player } from "../objects/player";

export class GameScene extends Phaser.Scene {
    private background: Phaser.GameObjects.Image;
    private coin: Coin;
    private player: Player;
    private player2: Player;

    private collectedCoins: number = 0;
    private coinsCollectedText: Phaser.GameObjects.Text;

    constructor() {
        super({
            key: "GameScene"
        });
    }

    preload(): void {
        this.load.image("background", require("/src/assets/games/coinRunner/background.png"));
        this.load.image("player", require("/src/assets/games/coinRunner/player.png"));
        this.load.image("coin", require("/src/assets/games/coinRunner/coin.png"));
    }

    create(): void {
        // create background
        this.background = this.add.image(0, 0, "background");
        this.background.setOrigin(0, 0);

        // create objects
        this.coin = new Coin({
            scene: this,
            x: Phaser.Math.RND.integerInRange(100, 700),
            y: Phaser.Math.RND.integerInRange(100, 500),
            key: "coin"
        });

        // Create Keyboards
        var cursors1 = this.input.keyboard.createCursorKeys();
        var cursors2 = this.input.keyboard.addKeys({
            up: Phaser.Input.Keyboard.KeyCodes.W,
            down: Phaser.Input.Keyboard.KeyCodes.S,
            left: Phaser.Input.Keyboard.KeyCodes.A,
            right: Phaser.Input.Keyboard.KeyCodes.D,
        });


        this.player = new Player({ scene: this, x: 150, y: 300, key: "player", keyboard: cursors1 });
        this.player2 = new Player({ scene: this, x: 150, y: 300, key: "player", keyboard: cursors2 });


        // var logo = this.physics.add.image(400, 100, 'player');
        // logo.setVelocity(100, 200);
        // logo.setBounce(1, 1);
        // logo.setCollideWorldBounds(true);
        var particles = this.add.particles("player");
        var emitter = particles.createEmitter({
            lifespan: 2000,
            angle: { min: 230, max: 310 },
            gravityY: 115,
            speed: { min: 85, max: 200 },
            scale: { start: .3, end: 0 },
            quantity: 0.5,
            blendMode: 'ADD'
        });
        // emitter.startFollow(logo);
        emitter.startFollow(this.player, 0, -20);

        // create texts
        this.coinsCollectedText = this.add.text(
            this.sys.canvas.width / 2,
            this.sys.canvas.height - 50,
            this.collectedCoins + "",
            {
                fontFamily: "Connection",
                fontSize: 38,
                stroke: "#fff",
                strokeThickness: 6,
                fill: "#000000"
            }
        );
    }

    update(): void {
        // update player and coin
        this.player.update();
        this.player2.update();
        this.coin.update();

        // do the collision check
        if (
            Phaser.Geom.Intersects.RectangleToRectangle(
                this.player.getBounds<Phaser.Geom.Rectangle & Phaser.Math.Vector2>(),
                this.coin.getBounds<Phaser.Geom.Rectangle & Phaser.Math.Vector2>()
            ) || Phaser.Geom.Intersects.RectangleToRectangle(
                this.player2.getBounds<Phaser.Geom.Rectangle & Phaser.Math.Vector2>(),
                this.coin.getBounds<Phaser.Geom.Rectangle & Phaser.Math.Vector2>()
            )
        ) {
            this.updateCoinStatus();
        }
    }

    private updateCoinStatus(): void {
        this.collectedCoins++;
        this.coinsCollectedText.setText(this.collectedCoins + "");
        this.coin.changePosition();
    }

    private gameover(): void {
        this.scene.start("GameScene");
    }
}



// WEBPACK FOOTER //
// ./src/games/demos/phaserDemo/scenes/gameScene.ts